import { render, staticRenderFns } from "./HealthProfessionFieldForm.vue?vue&type=template&id=d54c79fa&v-if=internal&"
import script from "./HealthProfessionFieldForm.vue?vue&type=script&lang=ts&"
export * from "./HealthProfessionFieldForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VSwitch,VTextField})
